module.exports = __webpack_public_path__ + "static/img/2.f807bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/2.jpg
// module id = Ybts
// module chunks = 1